import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { ListHealthClaimUserApproveResponse } from './types'
import api from '@/constant/END_POINT'

const fetchListHealthClaimUserApprove = async (params: {
  search: string
  page: number
  limit: number
}) => {
  const search = params.search ? `search=${params.search}&` : ''

  const response = await httpClientPrivate.get<ListHealthClaimUserApproveResponse>(
    api.backoffice.listHealthClaimUserApprove(search, params.page, params.limit),
  )

  return response.data
}

const useListHealthClaimUserApprove = (params: {
  search: string
  page: number
  limit: number
  enabled: boolean
}) => {
  const queryKey = ['useListHealthClaimUserApprove', params]
  const queryFn = async () => fetchListHealthClaimUserApprove(params)
  const queryResult = useQuery({ queryKey, queryFn, enabled: params.enabled })

  return { ...queryResult }
}

export { fetchListHealthClaimUserApprove, useListHealthClaimUserApprove }
